<div class="dt-progress-bar" [style]="setting">
  <div class="dt-progress-bar__fill" [ngStyle]="{'width.%': progressBarService.progress}"></div>
</div>